// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"227865df","667":"5a5e00ea"}[chunkId] + ".chunk.js";
};